import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import JwtStore from './JwtStore'
import dispatchHttpError from '../utils/dispatchHttpError';

import checkStatus from '../utils/checkStatus';
import api from '../utils/api';

export default {
  saveActivity(activity) {
    return fetch(api('content-activities'),{
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(activity),
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.PRODUCT_FOCUS_GROUP_CONTENT_VIEWED_COMPLETED,
        productFocus: response.data,
      }))
      .catch(dispatchHttpError);
  }
}
